import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Force le scroll en haut de la page à chaque changement de route.
 * Sans ça, React Router conserve la position de scroll lors de la navigation.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
